/*
 * $Id:: sidebarItems.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

export default {
    unauth: [],
    auth: [
        { key: 'DASHBOARD', value: 'dashboard', path: '/', isDefault: true, id: 'dashboard-menu' },
        {
            key: 'ONLINE_SERVICES',
            value: 'online.services',
            path: '/online-services',
            id: 'online-services-menu',
            subMenuOpen: true,
            submenu: [
                { key: 'TRADEMARKS', value: 'trademarks', path: '/online-services/trademark', id: 'trademarks-menu' },
                { key: 'DESIGNS', value: 'designs', path: '/online-services/design', id: 'designs-menu' },
                { key: 'PATENTS', value: 'patents', path: '/online-services/patents', id: 'patents-menu' },
            ],
        },
        {
            key: 'MY_APPLICATIONS',
            value: 'my.applications',
            path: '/my-applications',
            id: 'my-applications-menu',
            subMenuOpen: true,
            submenu: [
                { key: 'TRADEMARKS', value: 'trademarks', path: '/my-applications/trademark', id: 'trademarks-menu' },
                { key: 'DESIGNS', value: 'designs', path: '/my-applications/design', id: 'designs-menu' },
                { key: 'PATENTS', value: 'patents', path: '/my-applications/patents', id: 'patents-menu' },
            ],
        },
        // {
        //     key: 'DRAFT_APPLICATIONS',
        //     value: 'my.draft.applications',
        //     path: '/my-drafts',
        //     id: 'draft-applications-menu',
        //     subMenuOpen: true,
        //     submenu: [
        //         { key: 'TRADEMARKS', value: 'trademarks', path: '/my-drafts/trademark', id: 'trademarks-menu' },
        //         { key: 'DESIGNS', value: 'designs', path: '/my-drafts/design', id: 'designs-menu' },
        //         { key: 'PATENTS', value: 'patents', path: '/my-drafts/patents', id: 'patents-menu' },
        //     ],
        // },
        // {
        //     key: 'MY_ACCOUNT',
        //     value: 'my.account',
        //     path: '/my-account/login-details',
        //     id: 'my-account-menu',
        //     redirectTo: '/',
        //     submenu: [
        //         { key: 'LOGIN_DETAILS', value: 'login.details', path: '/my-account/login-details', id: 'login-details-menu', includeParam: true },
        //         {
        //             key: 'CHANGE_PASSWORD',
        //             value: 'profile.details',
        //             path: '/my-account/profile-details',
        //             id: 'change-password-menu',
        //             includeParam: true,
        //         },
        //         { key: 'PREFERENCES', value: 'preferences', path: '/my-account/preferences', id: 'preferences-menu', includeParam: true },
        //         {
        //             key: 'CHILD_ACCOUNTS',
        //             value: 'child.accounts',
        //             path: '/my-account/child-accounts',
        //             id: 'child-accounts-menu',
        //             includeParam: true,
        //         },
        //         {
        //             key: 'CREATE_CHILD_ACCOUNT',
        //             value: 'create.child.account',
        //             path: '/child-accounts/create',
        //             id: 'create-child-account-menu',
        //             cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_ACCOUNT_ADMINISTRATOR'),
        //         },
        //         {
        //             key: 'EDIT_CHILD_ACCOUNT',
        //             value: 'edit.child.account',
        //             path: '/child-accounts/edit',
        //             id: 'edit-child-account-menu',
        //             cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_ACCOUNT_ADMINISTRATOR'),
        //         },
        //     ],
        // },
        // { key: 'SIGNATURES', value: 'signatures', path: '/signatures' },
        // {
        //   key: 'PAYMENTS',
        //   value: 'payments',
        //   submenu: [
        //     { key: 'SHOPPING_CART', value: 'shopping.cart', path: '/payments/shopping-cart' },
        //     { key: 'PAYMENT_HISTORY', value: 'payment.history', path: '/payments/payment-history' },
        //   ],
        // },
        // { key: 'CORRESPONDENCE', value: 'Correspondence', path: '/Correspondence' },
        {
            id: 'e-delivery-menu',
            key: 'EDELIVERY',
            value: 'edelivery',
            path: 'edelivery.url',
            cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_EDELIVERY'),
            externalPath: true,
        },

        {
            id: 'e-delivery-management-menu',
            key: 'EDELIVERY_MANAGEMENT',
            value: 'electronic.communication.management',
            path: 'edelivery.management.url',
            cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_EDELIVERY_MANAGEMENT'),
            externalPath: true,
        },

        {
            key: 'UPDATE_OWNER_INFORMATION',
            value: 'update.owner.information',
            path: 'update.owners.information.url',
            id: 'update-owner-information-menu',
            cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_UPDATE_OWNER_INFORMATION'),
            externalPath: true,
        },
        {
            key: 'PORTFOLIO',
            value: 'portfolio.text.sidebar',
            path: 'portfolio.url',
            id: 'portfolio-menu',
            cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_PORTFOLIO'),
            externalPath: true,
        },

        {
            id: 'impersonate-user-menu',
            key: 'IMPERSONATE_USER',
            value: 'impersonate.user',
            path: '/impersonate-user',
            cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_IMPERSONATE_READ'),
        },
        { key: 'LOGOUT', value: 'log.out', path: 'logout', id: 'logout-menu', logout: true },
    ],
};
